"use client";
import { useEffect } from 'react';

export default function Error({ error, reset }: { error: Error & { digest?: string }, reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="p-8 max-w-3xl mx-auto text-center">
      <h1 className="text-3xl font-bold">Something went wrong</h1>
      <p className="mt-2 text-gray-600">An unexpected error occurred. Please try again.</p>
      <button onClick={() => reset()} className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded">Try again</button>
    </main>
  );
}
